import type { ImagePickerAsset } from 'expo-image-picker';

import { useSharedMediaApi } from '@/features/api/hooks/shared-media/useSharedMediaApi';
import { useApiMutation } from '@/features/api/hooks/useApiMutation';
import { toBlob } from '@/features/api/utils/blob';
import { processImage } from '@/features/media/utils/image';

export const useUploadTemporaryMediaItem = () => {
  const api = useSharedMediaApi();

  return useApiMutation({
    mutationFn: async (image: ImagePickerAsset) => {
      const uri = await processImage(image);
      const file = await toBlob(uri);
      return api.uploadTemporaryMediaItem({ file });
    },
    onError: (e) => {
      console.error(
        '[useUploadTemporaryMediaItem]: temporary image upload failed',
        e
      );
    }
  });
};
